<template>
  <div class="fileManage">
    <div class="header-btn">
      <div class="btn-left">
        <el-popover trigger="click" placement="bottom-end" :visible-arrow='false' ref="project"
          @after-leave="downloadHide" popper-class="file-download">
          <el-cascader-panel :props='props' v-model="downloadStr" :options="projectOptionChange()"
            @change='downloadProject($event)'>
          </el-cascader-panel>
          <el-button slot="reference" class="download">{{ $t('projectV2.download') }}</el-button>
        </el-popover>
      </div>
      <div class="btn-right">
        <el-input :placeholder="$t('fileManage.retrieve')" v-model="searchKeyword" size="small">
          <el-button slot="append" icon="el-icon-search" @click="handleJumpSearch"></el-button>
        </el-input>
        <!-- 筛选框 -->
        <el-popover placement="bottom" trigger="click" :title="$t('projectV2.filter')" popper-class="project-screen">
          <ul>
            <li>
              <el-input :placeholder="$t('projectDetailsV2.pleaseiputFile')" v-model="select.fileName" size="small">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </li>
            <li>
              <p>{{ $t('memory.sourceLang') }}</p>
              <el-select size="small" @change="changeSource" v-model="select.sourceLang"
                :placeholder="$t('newProjectV2.langPairTip')">
                <el-option v-for="(item, index) in filterDate.sourceLangList" :key="index"
                  :label="$i18n.locale === 'zh' ? item.name : $langCase[item.code]" :value="item.code"></el-option>
              </el-select>
            </li>
            <li>
              <p>{{ $t('memory.targetLang') }}</p>
              <el-select size="small" v-model="select.targetLang" :placeholder="$t('newProjectV2.langPairTip')"
                @change="changeTarget">
                <el-option v-for="(item, index) in filterDate.targetLangList" :key="index"
                  :label="$i18n.locale === 'zh' ? item.name : $langCase[item.code]" :value="item.code"></el-option>
              </el-select>
            </li>
            <li>
              <p>{{ $t('newProjectV2.domain') }}</p>
              <el-select size="small" v-model="select.domainCode" :placeholder="$t('newProjectV2.domainTip')">
                <el-option v-for="(item, index) in filterDate.domainNameList" :key="index"
                  :label="$i18n.locale === 'zh' ? item.domainName : $domainCase[item.domainCode]"
                  :value="item.domainCode">
                </el-option>
              </el-select>
            </li>
            <li>
              <p>{{ $t('task.project') }}</p>
              <el-select size="small" v-model="select.name" :placeholder="$t('fileManagement.SelectProject')">
                <el-option v-for="(item, index) in filterDate.projectNameList" :key="index" :label="item"
                  :value="item"></el-option>
              </el-select>
            </li>
            <li>
              <p>{{ $t('fileManagement.translationCompletionTime') }}</p>
              <el-date-picker v-model="filtrateTime" :clearable="false" type="datetimerange"
                :range-separator="$t('common.dateSeparator')" :start-placeholder="$t('common.startDate')"
                :end-placeholder="$t('common.endDate')" :default-time="['00:00:00']">
              </el-date-picker>
            </li>
            <li class="btn">
              <el-button @click="clearSearch">{{ $t('projectV2.clear') }}</el-button>
              <el-button type="primary" @click="getProject">{{ $t('projectV2.search') }}</el-button>
            </li>
          </ul>
          <el-button class="search" size="small" slot="reference">{{ $t('projectV2.filter') }}<i></i>
          </el-button>
        </el-popover>
        <!-- 筛选框 -->
      </div>
    </div>

    <!-- table列表 -->
    <div class="table">
      <el-table :data="tableList" @sort-change="sortChange" ref="multipleTable"
        :header-cell-style="{ background: '#F3F7FE', color: '#566087', textAlign: 'center', padding: '0', height: '50px', 'font-weight': 'bold' }"
        :cell-style="{ height: '48px' }" height="100%" border style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column class-name="selection" type="selection" width="50">
        </el-table-column>
        <el-table-column type="index" :index="indexMethod" width="55" align="center" :label="$t('projectV2.index')">
        </el-table-column>
        <el-table-column prop="name" :show-overflow-tooltip="true" align="left" min-width="110"
          :label="$t('newProjectV2.docName')">
          <template slot-scope="{row}">
            <div class="file-name" @click="toDetails(row)" style="text-align:left">
              {{ row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sourceLangName" :show-overflow-tooltip="true" :width="$i18n.locale === 'zh' ? '80' : 'auto'"
          align="center" :label="$t('newProjectV2.sourceLang')">
          <template slot-scope="{row}">{{ $i18n.locale === 'zh' ? row.sourceLangName :
            $langCase[row.sourceLang] }}</template>
        </el-table-column>
        <el-table-column prop="targetLangName" :show-overflow-tooltip="true" :width="$i18n.locale === 'zh' ? '80' : 'auto'"
          align="center" :label="$t('newProjectV2.targetLang')">
          <template slot-scope="{row}">{{ $i18n.locale === 'zh' ? row.targetLangName :
            $langCase[row.targetLang] }}</template>
        </el-table-column>
        <el-table-column prop="domainName" :show-overflow-tooltip="true" width="80" align="center"
          :label="$t('projectV2.domain')">
          <template slot-scope="{ row }">{{ $i18n.locale === 'zh' ? row.domainName :
            $domainCase[row.domainCode] }}</template>
        </el-table-column>
        <el-table-column prop="projectName" :show-overflow-tooltip="true" :label="$t('task.project')">
          <template slot-scope="{row}">
            <div class="project-name" @click="toProjectDetail(row)">
              {{ row.projectName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sourceWordNum" :show-overflow-tooltip="true" width="80" align="center"
          :label="$t('task.words')">
        </el-table-column>
        <el-table-column prop="sentCount" :show-overflow-tooltip="true" align="center"
          :label="$t('projectDetailsV2.sentenceNums')">
        </el-table-column>
        <el-table-column prop="fileSize" :show-overflow-tooltip="true" width="85" align="center"
          :label="$t('jobManagementV2.fileSize')">
          <template slot-scope="{row}">
            <div>
              {{ Math.round(row.fileSize / 1024 * 100) / 100 + 'KB' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="transCompleteTime" sortable="custom" :show-overflow-tooltip="true" align="center"
          width="140" :label="$t('fileManagement.translationCompletionTime')">
          <template slot-scope="{row}">
            <div class="time">
              {{ row.transCompleteTime || '--' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" :width="$i18n.locale === 'zh' ? '100' : 'auto'" :label="$t('common.operation')">
          <template slot-scope="{row}">
            <div class="operation">
              <el-tooltip effect="dark" :content="$t('memory.detail')" placement="top">
                <span class="item-check" @click="toDetails(row)"></span>
              </el-tooltip>
              <el-tooltip effect="dark" :content="$t('common.download')" placement="top">
                <el-popover :offset="20" placement="left" trigger="click" popper-class="setting-list"
                  :ref="`popover-${row.id}`" @after-leave="downloadHide">
                  <el-cascader-panel :options="projectOptionChange()" :props='props' v-model="downloadStr"
                    @change='downloadFile($event, row)'>
                  </el-cascader-panel>
                  <span slot="reference" class="item-down" @click="cascaderBoundEvent(row.id)"></span>
                </el-popover>
              </el-tooltip>
              <!-- <el-tooltip effect="dark" :content="$t('common.del')" placement="top">
                <span class="item-del" @click="handleDel(row.id)"></span>
              </el-tooltip> -->
            </div>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <!-- table列表 -->
    <div class="project-pagination">
      <el-pagination layout="prev, pager, next,sizes" :pager-count="5" :total="total" :page-sizes="[10, 20, 30, 40]"
        :page-size="query.rows" @current-change="handleCurrentChange" :current-page="query.page"
        @size-change="handleSizeChange" ref="pagination">
      </el-pagination>
    </div>

    <DelDialog Dialog width="480px" :dialogVisible="delVisible" @handleClose="closeDel" @handleConfirm="delProject">
      {{ $t('projectV2.delProjectTip') }}</DelDialog>

    <div v-show="isDownloadLoading" id="downloadLoadingBox">
      <div class="loadingMain">
        <i class="el-icon-loading"></i>
        <p>{{ $t('projectDetailsV2.downloading') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { apiRoot } from '@/services/ajax';
import { filterTime } from "@/utils/index";
import { queryPage, deleteFile, filterData } from "@/services/fileManage";
import { getDownloadAsyncResult, exportAsyncTransFile, exportTransFileXlf, exportTransFileTmx } from '@/services/projectDetailsApi';
import DelDialog from '@/components/delDialog';
export default {
  name: "fileManage",
  components: {
    DelDialog,
  },
  data() {
    return {
      delVisible: false, //删除弹窗
      tableList: [],//表格数据
      multipleSelection: [],//选中表格id
      filtrateTime: [],    //筛选时间
      total: null,
      select: {       //筛选条件
        name: "",
        fileName: "",
        sourceLang: "",
        targetLang: "",
        domainCode: "",
        startCreateTime: "",
        endCreateTime: "",
      },
      query: {
        filter: {
          userId: "",
        },
        page: 1,
        rows: 10,
        sort: { transCompleteTime: 'desc' },
      },
      multiple: false,
      deleteId: "",
      delProjectId: "",
      downloadStr: "",
      props: {
        expandTrigger: 'hover',
        emitPath: false,
      },
      downloadFileName: "",
      isDownloadLoading: false,
      filterDate: {
        sourceLangList: [],
        targetLangList: [],
      },
      searchKeyword: '',
      cloneSourceLangList: [],
      cloneTargetLangList: [],
      transModel: 0
    }
  },
  mounted() {
    this.query.filter.userId = String(JSON.parse(localStorage.userInfo).id)
    this.getQueryPage()
    this.filterData()
  },
  methods: {
    changeSource(value) {
      this.select.targetLang=''
      this.filterDate.targetLangList = this.cloneTargetLangList.filter(item => {
        return item.code !== value;
      })
    },
    changeTarget(value) {

      // this.filterDate.sourceLangList = this.cloneSourceLangList.filter(item => {
      //   return item.code !== value;
      // })
    },
    cascaderBoundEvent(id) {
      let self = this
      const settingListNodes = this.$refs[`popover-${id}`].$refs.popper
      let cascaderNodes = settingListNodes.querySelectorAll('.el-cascader-node')
      for (let i = 0; i < cascaderNodes.length; i++) {
        cascaderNodes[i].addEventListener('mouseenter', () => {
          self.$nextTick(() => {
            self.$refs[`popover-${id}`].updatePopper()
          })
        })
      }
    },
    toProjectDetail(row) {
      this.$router.push({
        name: 'ProjectDetail',
        query: {
          id: row.projectId
        }
      })
    },
    async filterData() {
      let params = {
        userId: this.query.filter.userId,
        transModel: this.transModel
      }
      const { result, success } = await filterData(params)
      if (success) {
        this.filterDate = result;
        this.cloneSourceLangList = result.sourceLangList;
        this.cloneTargetLangList = result.targetLangList;
        this.filterData.sourceLangList = result.sourceLangList
        this.filterData.targetLangList = result.targetLangList
      }
    },
    //跳转详情页
    toDetails(row) {
      this.$router.push({
        name: "filePreview",
        query: {
          key: this.$Base64.encode(JSON.stringify({
            id: row.id,
            langDesc: row.langDesc,
            name: row.name,
            sourceLang: row.sourceLang,
            targetLang: row.targetLang,
            // 进入预览需要
            intoType: 'fileManage',
          }))
        }
      })
    },
    handleJumpSearch() {
      if (this.searchKeyword === '') {
        return;
      }
      this.$router.push({
        name: 'fileSearch',
        params: {
          key: this.$Base64.encode(JSON.stringify({
            searchKeyword: this.searchKeyword,
          })),
        },
        query: {
          key: this.$Base64.encode(JSON.stringify({
            searchType: 'fileManage',
          })),
        },
      });
    },
    indexMethod(index) {
      return index + 1
    },
    // 单个文件下载
    downloadFile(val, row) {
      let id = row.id;
      let type = null
      this.$refs[`popover-${id}`].doClose();
      switch (val) {
        case 'original':
          type = 6
          this.onDownload(type, id);
          break;
        case 'translate-translation':
          type = 1
          this.onDownload(type, id);
          break;
        case 'translate-contrast':
          type = 2
          this.onDownload(type, id);
          break;
        case 'proofread-translation':
          type = 3
          this.onDownload(type, id);
          break;
        case 'proofread-contrast':
          type = 4
          this.onDownload(type, id);
          break;
        case 'review-translation':
          type = 11
          this.onDownload(type, id);
          break;
        case 'review-contrast':
          type = 12
          this.onDownload(type, id);
          break;
        case 'modify':
          type = 5
          this.onDownload(type, id);
          break;
        case 'XLFreport':
          this.onDownloadXlf(id);
          break;
        case 'TMXreport':
          this.onDownloadTmx(id);
          break;
      }
    },
    async onDownload(type, id) {
      let param = {
        type,
        fileId: id
      };
      let { resultCode, result } = await exportAsyncTransFile(param);
      if (resultCode !== "1") {
        return;
      }
      if (result.percent == 100) {
        this.downloadServerFile(result.fileName, result.downloadUrl)
      } else {
        this.isDownloadLoading = true;
        this.getDownloadAsyncResult(result.taskKey);
      }
    },
    async onDownloadXlf(id) {
      let { resultCode, result } = await exportTransFileXlf({ id });
      if (resultCode === '1') {
        window.open(result);
        this.isDownloadLoading = false;
      }
    },
    async onDownloadTmx(id) {
      let { resultCode, result } = await exportTransFileTmx({ id });
      if (resultCode === '1') {
        window.open(result);
        this.isDownloadLoading = false;
      }
    },
    //多条下载
    downloadProject(value) {
      if (this.multipleSelection.length < 1) {
        this.$message.closeAll()
        this.$message.warning(this.$t('fileManagement.selectdownloadFirst'))
        return
      }
      let type = null;
      this.$refs.project.doClose();
      switch (value) {
        case 'original':
          type = 6;
          this.downloadFileName = '（原文）.zip';
          break;
        case 'translate-translation':
          type = 1;
          this.downloadFileName = '（翻译译文）.zip';
          break;
        case 'translate-contrast':
          type = 2;
          this.downloadFileName = '（翻译原译对照）.zip';
          break;
        case 'proofread-translation':
          type = 3;
          this.downloadFileName = '（审校译文）.zip';
          break;
        case 'proofread-contrast':
          type = 4;
          this.downloadFileName = '（审校原译对照）.zip';
          break;
        case 'review-translation':
          type = 11;
          this.downloadFileName = '（复审译文）.zip';
          break;
        case 'review-contrast':
          type = 12;
          this.downloadFileName = '（复审原译对照）.zip';
          break;
        case 'modify':
          type = 5;
          this.downloadFileName = '（修订痕迹）.zip';
          break;
        case 'TMXreport':
          type = 7;
          this.downloadFileName = '（TMX文档）.zip';
          break;
        case 'QAreport':
          type = 8;
          this.downloadFileName = '（QA报告）.zip';
          break;
        case 'XLFreport':
          type = 10;
          this.downloadFileName = '（XLF文档）.zip';
          break;
        default:
          break;
      }
      // if (type !== 6 && this.projectInfo.finish === 0) {
      //   this.$message.closeAll();
      //   this.$message.warning(this.$t('projectV2.porjectNotBeginNotDownload'))
      //   return;
      // }
      this.asynchronizationDownload(`/api/v1/file/exportAsyncFile?type=${type}&fileList=${this.multipleSelection}&projectId=1`);
      this.$refs.multipleTable.clearSelection();
    },
    // 下载（异步）
    async asynchronizationDownload(url) {
      const response = await this.catReq1Service(url, {}, 'get')
      if (response.resultCode === "1") {
        const result = response.result;
        if (result.percent == 100) {
          this.downloadServerFile(result.fileName, result.downloadUrl);
        } else {
          this.isDownloadLoading = true;
          this.getDownloadAsyncResult(result.taskKey)
        }
      }
    },
    // a链接下载
    downloadServerFile(fileName, filePath) {
      let link = document.createElement("a");
      link.style.display = "none";
      if (this.downloadFileName !== '') {
        fileName = this.downloadFileName;
      }
      link.href = apiRoot(`/file/downloadServerFile?fileName=${fileName}&filePath=${filePath}`);
      link.setAttribute("download", fileName);
      this.downloadFileName = '';
      document.body.appendChild(link);
      link.click();
    },
    // 轮询下载
    async getDownloadAsyncResult(taskKey) {
      let setItem = setInterval(async () => {
        let { resultCode, result } = await getDownloadAsyncResult({ taskKey });
        if (resultCode === "1") {
          if (parseInt(result.percent) === 100) {
            clearInterval(setItem);
            setItem = null;
            this.isDownloadLoading = false;
            this.downloadServerFile(result.fileName, result.downloadUrl)
          }
        } else {
          clearInterval(setItem);
          setItem = null;
          this.isDownloadLoading = false;
        }
      }, 2000);
    },
    //下载展开数据
    projectOptionChange() {
      return [
        { label: this.$t('projectV2.original'), value: 'original' },
        {
          label: this.$t('projectV2.translate'), value: 'translate', children: [
            { label: this.$t('projectV2.translation'), value: 'translate-translation' },
            { label: this.$t('projectV2.contrast'), value: 'translate-contrast' }
          ]
        },
        { label: this.$t('projectV2.revise'), value: 'modify' },
        { label: this.$t('projectV2.archive'), value: 'TMXreport' },
        { label: this.$t('projectV2.xlfreport'), value: 'XLFreport' },
      ];
    },
    // 级联隐藏
    downloadHide() {
      this.downloadStr = '';
    },
    //确认删除
    async delProject() {
      let params
      if (this.multiple) {
        params = {
          idList: this.multipleSelection
        }
      } else {
        params = {
          idList: [this.delProjectId]
        }
      }
      const { success } = await deleteFile(params)
      if (success) {
        this.$message.closeAll()
        this.$message.success(this.$t('team.deletedTrue'))
        this.delVisible = false
        this.$refs.multipleTable.clearSelection();
        this.getQueryPage()
      }
    },
    //删除取消
    closeDel() {
      this.delVisible = false
    },
    //删除弹窗展示
    deleteList() {
      if (this.multipleSelection.length < 1) {
        this.$message.closeAll();
        this.$message.warning(this.$t('fileManagement.selectfiledelete'))
        return
      }
      this.multiple = true
      this.delVisible = true
    },
    handleDel(id) {
      this.delVisible = true;
      this.delProjectId = id;
    },
    //切换页面
    handleCurrentChange(currentPage) {
      this.query.page = currentPage
      this.getQueryPage()
    },
    handleSizeChange(currentSize) {
      this.query.rows = currentSize
      this.query.page = 1
      this.getQueryPage()
    },
    //表格排序
    sortChange({ column, prop, order }) {
      if (order == 'descending') {
        this.query.sort[prop] = 'desc'
      } else if (order === 'ascending') {
        this.query.sort[prop] = 'asc'
      } else {
        this.query.sort[prop] = 'desc'
      }
      this.getQueryPage()
    },
    //选中table
    handleSelectionChange(val) {
      this.multipleSelection = val.map(item => {
        return item.id
      })
    },
    //获取分页
    async getQueryPage() {
      let params = this.query
      for (let index in params.filter) {
        if (params.filter[index] == "") {
          delete params.filter[index]
        }
      }
      const { success, list, totalRows } = await queryPage(params)
      if (success) {
        this.tableList = list
        this.total = totalRows
        // if (this.query.page > 1 && list.length < 1) {
        //   this.query.page--
        //   this.getQueryPage()
        // }
      }
    },
    //筛选搜索
    getProject() {
      if (this.filtrateTime.length > 1) {
        this.select.startCreateTime = filterTime(this.filtrateTime[0])
        this.select.endCreateTime = filterTime(this.filtrateTime[1])
      }
      this.query.filter = { ...this.query.filter, ...this.select }
      this.getQueryPage()
    },
    //筛选清楚
    clearSearch() {
      for (let index in this.select) {
        this.select[index] = ""
      }
      this.filterDate.sourceLangList = JSON.parse(JSON.stringify(this.cloneSourceLangList))
      this.filterDate.targetLangList = JSON.parse(JSON.stringify(this.cloneTargetLangList))
      this.filtrateTime = []
      this.query.filter = { ...this.query.filter, ...this.select }
      this.getQueryPage()
    },
  },
}
</script>

<style lang="less" scoped>
.fileManage {
  background: #fff;
  width: 100%;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;

  .header-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    .btn-left {
      .el-button {
        padding: 0 15px;
        height: 32px;
        border-radius: 4px;
        padding: 0;
        font-size: 14px;
        line-height: 30px;
      }

      .download {
        padding: 0 15px;
        // margin-right: 20px;
        color: #fff !important;
        background: #0078fc;
        border: 1px solid #0078fc;
      }

      .delete {
        color: #0078fc;
        border: 1px solid #0078fc;
      }
    }

    .btn-right {
      display: flex;
      line-height: 30px;

      .el-input-group {
        margin-right: 15px;

        /deep/ .el-input-group__append {
          background: #0078fc;
          color: #fff;
        }
      }
    }

    .el-popover__reference-wrapper {
      .search {
        height: 32px;
        padding: 0 10px;
        font-size: 14px;
        border-color: 1px solid #e5e7eb;
        color: #5c6a86;

        i {
          width: 14px;
          height: 14px;
          display: inline-block;
          vertical-align: -2px;
          background: url("./assets/images/icon-search.png");
          margin-left: 5px;
        }
      }
    }
  }

  .table {
    width: 100%;
    height: calc(100% - 91px);

    /deep/ .el-table__cell {
      text-align: center;
    }

    /deep/.gutter {
      background-color: #f3f7fe;
    }

    .operation {
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        display: inline-block;
        width: 16px;
        height: 16px;
        cursor: pointer;
      }

      span+span {
        margin-left: 20px;
      }

      .item-check {
        background: url("./assets/images/see_pre.png") no-repeat center;
        background-size: 16px 16px;

        &:hover {
          background: url("./assets/images/see_normal.png") no-repeat center;
          background-size: 16px 16px;
        }
      }

      .item-down {
        background: url("./assets/images/icon-export.png") no-repeat center;
        background-size: 16px 16px;

        &:hover {
          background: url("./assets/images/icon-export-pre.png") no-repeat center;
          background-size: 16px 16px;
        }
      }

      .item-del {
        background: url("./assets/images/icon-del.png") no-repeat center;
        background-size: 16px 16px;

        &:hover {
          background: url("./assets/images/icon-del-pre.png") no-repeat center;
          background-size: 16px 16px;
        }
      }
    }

    .time {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .file-name {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #0078fc;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .project-name {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #0078fc;
      text-align: left;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .project-pagination {
    text-align: center;

    /deep/ .el-pagination {
      box-sizing: border-box;
      height: 28px;
      margin-top: 15px;
      padding: 0;

      button {
        display: inline-block;
        min-width: 30px;
        height: 28px;
        box-sizing: border-box;
      }

      .el-pagination__sizes {
        line-height: 0;
      }

      .btn-prev,
      .btn-next {
        box-sizing: border-box;
        width: 30px !important;
        padding: 0;
        border: 1px solid #c0cccc;
        border-radius: 3px;
      }

      .btn-prev {
        margin: 0 10px 0 5px;
      }

      .btn-next {
        margin: 0 5px;
      }

      .el-pager {
        li {
          min-width: 30px;
          height: 28px;
          line-height: 26px;
          border: 1px solid #c0cccc;
          border-radius: 3px;
          margin: 0 10px 0 5px;
        }

        .active {
          border: 1px solid #0087fc;
          color: #0078fc;
        }
      }
    }
  }

  #downloadLoadingBox {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.5;
    z-index: 1000;
    text-align: center;

    .loadingMain {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 20px;
      color: #fff;

      i {
        font-size: 30px;
      }
    }
  }
}
</style>
<style lang="less">
.setting-list,
.file-download {
  padding: 0;

  .el-cascader-panel {
    .el-cascader-menu {
      min-width: 130px;

      .el-scrollbar__wrap {
        ul {
          li {
            height: 32px;

            .el-icon-check {
              display: none;
            }

            .el-cascader-node__label {
              line-height: 32px;
            }
          }
        }
      }
    }
  }
}

.project-download {
  .el-scrollbar__wrap {
    height: auto;
  }

  .el-cascader-menu:last-child {
    .el-scrollbar__wrap {
      overflow-x: auto;
    }
  }

  .el-cascader-menu:first-child {
    .el-scrollbar__wrap {
      overflow-x: scroll;
    }
  }
}

.project-screen {
  .el-popover__title {
    font-weight: bold;
  }

  ul {
    width: 200px;

    li+li {
      color: #454545;
      text-align: left;
      margin-top: 12px;
    }

    li {
      .el-select {
        width: 100%;

        .el-input {
          width: 100%;
        }
      }

      .el-button+.el-button {
        margin-left: 20px;
      }

      .el-button {
        padding: 0 20px;
        height: 32px;
        line-height: 32px;
      }

      .el-button--default {
        color: #0078fc;
        border: 1px solid #0078fc;
      }
    }

    .btn {
      text-align: center;
    }

    .el-input__inner {
      width: 200px;
      height: 32px;

      .el-range-separator {
        line-height: 25px;
        font-size: 1px;
        width: 20%;
      }

      .el-range-input {
        font-size: 1px;
        width: 100%;
      }

      .el-range__icon {
        line-height: 26px;
      }
    }
  }
}</style>